import clsx from 'clsx';
import { Banner, Icon, Tooltip } from '@hevoio/hevo-ui-toolkit';
import styles from './UpgradePipelineBanner.module.scss';
import { StandardPipeline } from '../interfaces/integration';

export interface UpgradePipelineBannerProps {
  isObjectConfigPage: boolean;
  standardPipelineInfo?: StandardPipeline;
  className?: string;
}

export function UpgradePipelineBanner({
  isObjectConfigPage,
  standardPipelineInfo,
  className
}: UpgradePipelineBannerProps) {
  const standardSourceName = standardPipelineInfo?.source_name;
  const standardDestinationName = standardPipelineInfo?.dest_name;

  return standardPipelineInfo ? (
    <div className={clsx(styles.upgradePipelineBannerContainer, className)}>
      <Banner
        open
        dataId='upgrade-pipeline-banner'
        className={styles.upgradePipelineBanner}
        color='primary'
        icon='info'
        iconClass='text-info'
      >
        {isObjectConfigPage ? (
          <span>
            All objects from your Standard Pipeline are pre-selected, but incompatible fields or
            objects will be highlighted.
          </span>
        ) : (
          <div className='d-flex align-items-center overflow-hidden'>
            <span className='mr-2 flex-shrink-0'>
              Upgrading pipeline from Standard to Edge: #{standardPipelineInfo.seq_id}/
            </span>

            <div className='d-flex flex-1 align-items-center overflow-hidden'>
              <img
                data-id='source-type-icon'
                src={standardPipelineInfo.source_type_logo_url as string}
                alt='Source Type Icon'
                className={clsx(styles.pipelineNodesImg, 'mr-2')}
              />

              <Tooltip title={standardSourceName} enableOnTextOverflow dataId=''>
                <span className='text-body-1 mr-2 text-ellipsis'>{standardSourceName}</span>
              </Tooltip>

              <Icon name='add-arrow-right' size={2} className='mr-2' />

              <img
                style={{ width: '20px', height: '20px' }}
                data-id='destination-type-icon'
                src={standardPipelineInfo.dest_type_logo_url as string}
                alt='Destination Type Icon'
                className={clsx(styles.pipelineNodesImg, 'mr-2')}
              />

              <Tooltip title={standardDestinationName} enableOnTextOverflow dataId=''>
                <span className='text-body-1 text-ellipsis'>{standardDestinationName}</span>
              </Tooltip>
            </div>
          </div>
        )}
      </Banner>
    </div>
  ) : null;
}
